var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomElectricityPanel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 72,
    viewBox: "0 0 47 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 37,
    height: 61,
    x: 10,
    y: 5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 60,
    x: 10.5,
    y: 5.5,
    "data-svg-class": "RoomButton-stroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 29,
    height: 51,
    x: 13,
    y: 10,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 50,
    x: 13.5,
    y: 10.5,
    "data-svg-class": "RoomButton-stroke",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M25 16H14v5h11z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M24.5 16.5h-10v4h10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M25 23H14v5h11z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M24.5 23.5h-10v4h10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M25 30H14v5h11z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M24.5 30.5h-10v4h10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M25 37H14v5h11z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M24.5 37.5h-10v4h10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M25 44H14v5h11z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M24.5 44.5h-10v4h10z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M25 51H14v5h11z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M24.5 51.5h-10v4h10z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M3.316 4.815L17.684.185C19.515-.405 21 .46 21 2.117v67c0 1.657-1.485 2.522-3.316 1.932l-14.368-4.63C1.485 65.83 0 64.258 0 62.909V8.327c0-1.35 1.485-2.923 3.316-3.512z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M3.47 5.29C1.824 5.82.5 7.224.5 8.327v54.58c0 1.103 1.325 2.507 2.97 3.037l14.368 4.629c1.53.493 2.662-.166 2.662-1.456v-67c0-1.29-1.132-1.949-2.662-1.456L3.469 5.291z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 5,
    height: 17,
    x: 12,
    y: 27,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 16,
    x: 12.5,
    y: 27.5,
    "data-svg-class": "RoomButton-stroke",
    rx: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37 18h4M37 25h4M37 32h4M37 39h4M37 46h4M37 53h4",
    "data-svg-class": "RoomButton-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M27 16h11v5H27z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M27.5 16.5h10v4h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M27 23h11v5H27z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M27.5 23.5h10v4h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M27 30h11v5H27z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M27.5 30.5h10v4h-10z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M27 37h11v5H27z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M27.5 37.5h10v4h-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M27 44h11v5H27z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M27.5 44.5h10v4h-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M27 51h11v5H27z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M27.5 51.5h10v4h-10z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomElectricityPanel);
export default __webpack_public_path__ + "static/media/RoomElectricityPanel.4b92cbc01cf210c0bbe8c995c0d6be20.svg";
export { ForwardRef as ReactComponent };